// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Environment$Catalyst from "../node_modules/@porterin/catalyst/src/entities/Environment.bs.js";

var configObj = (require("Config"));

var env = configObj.app_env;

var vp_url = configObj.vp_url;

var partnerAppGatewayUrl = configObj.pag_url;

var oms_url = configObj.oms_url;

var pdf_generator_lambda_path = configObj.pdf_lambda_path;

var ga4_partner_app_tracking_id = configObj.ga_partner_app;

var ga4_rnr_tracking_id = configObj.ga_rnr;

var ga4_tlt_tracking_id = configObj.ga_tlt;

var sentry_dsn = configObj.sentry_dsn;

var enable2wCampaign = configObj.enable2wCampaign;

var dd_app_id = configObj.dd_app_id;

var dd_token = configObj.dd_token;

var infra_stack = configObj.infra_stack;

function getEnv(param) {
  return Environment$Catalyst.fromString(env);
}

function getSentryDsn(param) {
  return sentry_dsn;
}

function getCrmBaseUrl(param) {
  return window.location.origin;
}

function getHostName(param) {
  if (env === "development") {
    return "http://localhost:3000";
  } else {
    return oms_url;
  }
}

function getCMSUrl(param) {
  return configObj.cms_url;
}

function is2wCampaignEnabled(param) {
  if (enable2wCampaign === "false") {
    return false;
  } else {
    return true;
  }
}

function getRnrHostName(param) {
  return vp_url;
}

function getPdfGeneratorUrl(param) {
  return pdf_generator_lambda_path;
}

function getPdfGeneratorLambdaKey(param) {
  return process.env.PDF_GENERATOR_LAMBDA_KEY;
}

function getGoogleMapApiKey(param) {
  return process.env.GOOGLE_MAPS_API_KEY;
}

function getGa4TrackingId(param) {
  return ga4_partner_app_tracking_id;
}

function getGa4RnrTrackingId(param) {
  return ga4_rnr_tracking_id;
}

function getGa4TLTTrackingId(param) {
  return ga4_tlt_tracking_id;
}

function getPartnerAppGatewayUrl(param) {
  return partnerAppGatewayUrl;
}

var Env = {
  env: env,
  vp_url: vp_url,
  partnerAppGatewayUrl: partnerAppGatewayUrl,
  oms_url: oms_url,
  pdf_generator_lambda_path: pdf_generator_lambda_path,
  ga4_partner_app_tracking_id: ga4_partner_app_tracking_id,
  ga4_rnr_tracking_id: ga4_rnr_tracking_id,
  ga4_tlt_tracking_id: ga4_tlt_tracking_id,
  sentry_dsn: sentry_dsn,
  enable2wCampaign: enable2wCampaign,
  dd_app_id: dd_app_id,
  dd_token: dd_token,
  infra_stack: infra_stack,
  getEnv: getEnv,
  getSentryDsn: getSentryDsn,
  getCrmBaseUrl: getCrmBaseUrl,
  getHostName: getHostName,
  getCMSUrl: getCMSUrl,
  is2wCampaignEnabled: is2wCampaignEnabled,
  getRnrHostName: getRnrHostName,
  getPdfGeneratorUrl: getPdfGeneratorUrl,
  getPdfGeneratorLambdaKey: getPdfGeneratorLambdaKey,
  getGoogleMapApiKey: getGoogleMapApiKey,
  getGa4TrackingId: getGa4TrackingId,
  getGa4RnrTrackingId: getGa4RnrTrackingId,
  getGa4TLTTrackingId: getGa4TLTTrackingId,
  getPartnerAppGatewayUrl: getPartnerAppGatewayUrl
};

export {
  configObj ,
  Env ,
  
}
/* configObj Not a pure module */
